import { CircleNotch, PaperPlaneTilt } from '@phosphor-icons/react';

import pt from '../../locales/pt';
import { cn } from '../../utils/cn';

/**
 * Campo de mensagem com botão de envio integrado (estilo composer moderno).
 */
export function EvolutionAiComposer({
  value,
  onChange,
  onSubmit,
  disabled = false,
  isSending = false,
}) {
  const canSend = value.trim().length > 0 && !disabled && !isSending;

  return (
    <form
      className="relative"
      onSubmit={(event) => {
        event.preventDefault();
        if (canSend) onSubmit();
      }}
    >
      <div
        className={cn(
          'flex items-center rounded-full border bg-card pl-4 pr-1.5 shadow-sm transition-shadow',
          'border-border focus-within:border-sage-300 focus-within:ring-2 focus-within:ring-sage-200/80',
          disabled && 'opacity-60',
        )}
      >
        <input
          type="text"
          value={value}
          onChange={onChange}
          placeholder={pt.evolutionAi.placeholder}
          disabled={disabled || isSending}
          aria-label={pt.evolutionAi.placeholder}
          className="min-w-0 flex-1 border-0 bg-transparent py-3 text-base text-foreground placeholder:text-muted-foreground/70 focus:outline-none focus-visible:outline-none disabled:cursor-not-allowed"
        />
        <button
          type="submit"
          disabled={!canSend}
          aria-label={pt.evolutionAi.send}
          className={cn(
            'flex h-9 w-9 shrink-0 items-center justify-center rounded-full transition-all duration-200',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sage-400 focus-visible:ring-offset-2',
            canSend
              ? 'bg-gradient-to-br from-sage-600 to-emerald-700 text-white shadow-md hover:from-sage-700 hover:to-emerald-800 active:scale-95'
              : 'bg-muted text-muted-foreground/70',
          )}
        >
          {isSending ? (
            <CircleNotch className="h-4 w-4 animate-spin" aria-hidden />
          ) : (
            <PaperPlaneTilt className="h-4 w-4" aria-hidden />
          )}
        </button>
      </div>
    </form>
  );
}
